
<template>
  <div>
    <v-card flat>
      <v-card-text>
        <AddressForm ref="form" :address="one_address ? model.address_attributes : model.addresses_attributes"></AddressForm>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="emitChangeStepper(false)"><v-icon large color="red darken-2">mdi-arrow-up-bold</v-icon></v-btn>
        <v-btn text @click="emitChangeStepper(true)"><v-icon large color="green darken-2">mdi-arrow-down-bold</v-icon></v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'StepperAddress',
  props:{
    model:{
      type: Object,
      default: () => { return {} }
    },
    one_address:{
      type: Boolean,
      default: false,
    }
  },
  components:{
    AddressForm: () => import("@/_backoffice/_registrations/components/shared/forms/AddressForm.vue"),
  },
  methods: {
    validate(){
      return this.$refs.form.validate()
    },
    emitChangeStepper(increment){
      this.$emit("changeStepper", increment)
    },
  },
}
</script>